__webpack_require__.p = "/de/weiterbildung/dist/";